import React,{useState,useEffect} from 'react'
import Axios from 'axios'
import {useAlumno} from '../../../Context/alumnoContext'
import {gql,useQuery,useMutation,useLazyQuery} from '@apollo/client'
import REG_EX from '../../../Helpers/regex';
import moment from 'moment';
import { Box,Typography,Button, Card, Chip } from "@material-ui/core";
import { AlertDialog } from '../../../componentes/MUI/AlertDialog';
import {FormularioTramite} from '../../FormularioTramite'
import {TramiteContextProvider} from '../contexto/tramiteContext'
import {useTramite} from '../hooks/useTramite'
import { SubirArchivo } from '../../../componentes/formulariosFormik/SubirArchivo';
import {LoaderCircular} from '../../../componentes/LoaderCircular'
import {UbicacionInicial} from '../componentes/UbicacionInicial'
import {DatosPersonales} from '../componentes/DatosPersonales'
import {Contacto} from '../componentes/Contacto'
import {Cuestionario} from '../componentes/Cuestionario'
import {Cuestionario2} from '../componentes/Cuestionario2'
import {Pastores} from '../componentes/Pastores'
import {Referencias} from '../componentes/Referencias'
import regex from '../../../Helpers/regex'
import { isValidPhoneNumber  } from 'react-phone-number-input'
import {doPostFile,eliminarArchivos, hacerFoco,scrollTop} from '../../../Helpers/utilidades-globales'
import Swal from 'sweetalert2';
import { v4 as uuidv4 } from 'uuid';
import Aceptaciones1raCredencial from '../../../componentes/Aceptaciones1raCredencial';
import { 
  ArrowLeftIcon, 
} from '@heroicons/react/24/outline'; 
import BrowserUpdatedIcon from '@mui/icons-material/BrowserUpdated';


export const usePrimeraCredencial = ({datosPatrocinante})=>{

   const [loadingFile,setLoadingFile] = React.useState(false);
    const {usuario,snackbar} = useAlumno();
    const {campos_formulario,provincias,partidos,tiposDoc,nacionalidades,estadosCiviles,fechaEsValida,dniEstaEnUso,keyNoValida} = useTramite();
    const [objetoDinamico,setObjetoDinamico] = React.useState({usuario,paso1:null,nacionalidad:{id:3,nombre:'Argentina'}});
    const [continuar,setContinuar]=useState(false);
    const [validarCampos,setvalidarCampos]=useState(false);
    const [analiticoFile, setAnaliticoFile] = React.useState(null);
    const [dniFrenteFile, setDniFrenteFile] = React.useState(null);
    const [dniReversoFile, setDniReversoFile] = React.useState(null);
    const [foto4x4File, setFoto4x4File] = React.useState(null);
    const [antecedentes_penFile, setAntecedentesPenFile] = React.useState(null);
    const [certificadoMatrimonioFile, setCertificadoMatrimonioFile] = React.useState(null);
    const [documento,setDocumento] = React.useState(null);
    const [lecturas,setLecturas] = React.useState({});
    const [otroArchivo, setOtroArchivo] = React.useState(null);

    let adjuntos = [];

    useEffect(()=>{
      /*setObjetoDinamico({...objetoDinamico,nombre:datosPatrocinante.nombre, 
        apellido:datosPatrocinante.apellido,
        solicitante:datosPatrocinante.id_tramite.ministro.nombre,
        id_solicitante:datosPatrocinante.id_tramite.ministro.id,
        email:datosPatrocinante.email,
        id_region:datosPatrocinante.id_tramite.region,
        distrito:{id:datosPatrocinante.id_tramite.distrito.id,nombre:datosPatrocinante.id_tramite.distrito.nombre},
        sexo:datosPatrocinante.sexo,
        //provincia:{id:datosPatrocinante.provincia.id,nombre:datosPatrocinante.provincia.nombre},
        //partido:{id:datosPatrocinante.partido.id,nombre:datosPatrocinante.partido.nombre},
        provinciaigl:{id:datosPatrocinante.provincia.id,nombre:datosPatrocinante.provincia.nombre},
        partidoigl:{id:datosPatrocinante.partido.id,nombre:datosPatrocinante.partido.nombre},
        iglesia:{id:datosPatrocinante?.iglesia?.id,nombre:datosPatrocinante?.iglesia?.nombre},
        id_tramite_patrocinio:datosPatrocinante._id,
        doctrina:false,
        compromiso:null,
        estatutos:null,
        nombrepastor:'CARLOS ROJAS',nombreanciano:'FABIAN PLACANICA',emailpastor:'pablo.david.st@gmail.com',
        emailanciano:'pablo.david.st@gmail.com',
        dni:'23863311',
        celular:'11-5944-3002',
        telefono:'11-5944-3002',
        sostenimiento:'voy a trabajar todos los días',
        diezmo:'SI',pastores:['CARLOS NARANJO'],
        bautismo_es:'NO',
        //fecha_bautismo_a:'1995-01-01',
        //fecha_conversion:'1990-01-01',
        fecha_nacimiento:'1974-03-27',
        tipo_doc:{id:1,nombre:'DNI'},
        estado_civil:{id:4,nombre:'Soltero'}
      })*/
        setObjetoDinamico({...objetoDinamico,nombre:datosPatrocinante.nombre, 
                                              apellido:datosPatrocinante.apellido,
                                              solicitante:datosPatrocinante.id_tramite.ministro.nombre,
                                              id_solicitante:datosPatrocinante.id_tramite.ministro.id,
                                              email:datosPatrocinante.email,
                                              id_region:datosPatrocinante.id_tramite.region,
                                              distrito:{id:datosPatrocinante.id_tramite.distrito.id,nombre:datosPatrocinante.id_tramite.distrito.nombre},
                                              sexo:datosPatrocinante.sexo,
                                              provinciaigl:{id:datosPatrocinante.provincia.id,nombre:datosPatrocinante.provincia.nombre},
                                              partidoigl:{id:datosPatrocinante.partido.id,nombre:datosPatrocinante.partido.nombre},
                                              iglesia:{id:datosPatrocinante?.iglesia?.id,nombre:datosPatrocinante?.iglesia?.nombre},
                                              id_tramite_patrocinio:datosPatrocinante._id,
                                              doctrina:null,
                                              compromiso:null,
                                              estatutos:null,
                                            })
        hacerFoco('b-volver')
    },[])


    const callbackPrevio = async ()=>{

      setLoadingFile(true)

      if(!analiticoFile)
      {
        setLoadingFile(false)
        return [false,'Falta adjuntar el archivo de analítico']
      }

      if(!dniFrenteFile)
      {
        setLoadingFile(false)
        return [false,'Falta adjuntar el archivo con la foto del DNI (Frente)']
      }

      if(!dniReversoFile)
      {
        setLoadingFile(false)
        return [false,'Falta adjuntar el archivo con la foto del DNI (Reverso)']
      }

      if(!foto4x4File)
      {
        setLoadingFile(false)
        return [false,'Falta adjuntar la foto 4 x 4']
      }

      if(!antecedentes_penFile)
      {
        setLoadingFile(false)
        return [false,'Falta adjuntar el certificado de antecedentes penales']
      }

      if((objetoDinamico?.estado_civil?.id == 3 || objetoDinamico?.estado_civil?.id==6)){
          if(!certificadoMatrimonioFile)
          {
            setLoadingFile(false)
            return [false,'Falta adjuntar el certificado de matrimonio']
          }
      }

      try{

        const resultado_analitico = await doPostFile(analiticoFile,{id_obrero:objetoDinamico.dni},'analitico1cred','pdf')
        
        adjuntos.push(resultado_analitico[1] || 'unknown')

        if(!resultado_analitico[0])
        {
          setLoadingFile(false)
          eliminarArchivos(adjuntos)
          return [false,resultado_analitico[1]]
        }
        
        setLoadingFile(false)
  
        const resultado_dni_frente = await doPostFile(dniFrenteFile,{id_obrero:objetoDinamico.dni},'dni_frente1cred','pdf')
        adjuntos.push(resultado_dni_frente[1] || 'unknown')

        if(!resultado_dni_frente[0])
        {
          setLoadingFile(false)
          eliminarArchivos(adjuntos)
          return [false,resultado_dni_frente[1]]
        }
        
        setLoadingFile(false)

        const resultado_dni_reverso = await doPostFile(dniReversoFile,{id_obrero:objetoDinamico.dni},'dni_reverso1cred','pdf')
        adjuntos.push(resultado_dni_reverso[1] || 'unknown')

        if(!resultado_dni_reverso[0])
        {
          setLoadingFile(false)
          eliminarArchivos(adjuntos)
          return [false,resultado_dni_reverso[1]]
        }
        
        setLoadingFile(false)

        let adjuntos_aux = {}

        const resultado_foto4x4 = await doPostFile(foto4x4File,{id_obrero:objetoDinamico.dni},'foto_4x4cred','pdf')
        adjuntos.push(resultado_foto4x4[1] || 'unknown')


        if(!resultado_foto4x4[0])
        {
          setLoadingFile(false)
          eliminarArchivos(adjuntos)
          return [false,resultado_foto4x4[1]]
        }else{
          Object.assign(adjuntos_aux,{foto_4x4URL:resultado_foto4x4[1]})
        }
        
        setLoadingFile(false)

        const resultado_antecedentes_pen = await doPostFile(antecedentes_penFile,{id_obrero:objetoDinamico.dni},'antecedentes_pencred','pdf')
        adjuntos.push(resultado_antecedentes_pen[1] || 'unknown')


        if(!resultado_antecedentes_pen[0])
        {
          setLoadingFile(false)
          eliminarArchivos(adjuntos)
          return [false,resultado_antecedentes_pen[1]]
        }else{
          Object.assign(adjuntos_aux,{antecedentes_penURL:resultado_antecedentes_pen[1]})
        }
        
        setLoadingFile(false)
  
        if(certificadoMatrimonioFile){
            const resultado_cert_mat = await doPostFile(certificadoMatrimonioFile,{id_obrero:objetoDinamico.dni},'cert_matcred','pdf')
            adjuntos.push(resultado_cert_mat[1] || 'unknown')
    
            if(!resultado_cert_mat[0])
            {
              setLoadingFile(false)
              eliminarArchivos(adjuntos)
              return [false,resultado_cert_mat[1]]
            }else{
              Object.assign(adjuntos_aux,{cert_matURL:resultado_cert_mat[1]})
            }
            
            setLoadingFile(false)
        }
        
        let resultado_otroArchivo;

        if(otroArchivo){
          resultado_otroArchivo = await doPostFile(otroArchivo,{id_obrero:objetoDinamico.dni},'extra_1cred','pdf')
          adjuntos.push(resultado_otroArchivo[1] || 'unknown')

           if(!resultado_otroArchivo[0])
           {
             setLoadingFile(false)
             eliminarArchivos(adjuntos)
             return [false,resultado_otroArchivo[1]]
           }else{
            Object.assign(adjuntos_aux,{extra_1URL:resultado_otroArchivo[1]})
          }
          
        }

        return [true,{
          analiticoURL:resultado_analitico[1],
          dni_frenteURL:resultado_dni_frente[1],
          dni_reversoURL:resultado_dni_reverso[1],
          ...adjuntos_aux
          //ministro:'Prueba testing',    // AQUI PUEDO ENVIAR TODO TIPO DE DATOS QUE NO ESTAN EN EL
          //id_ministro:33                // FORMULARIO PERO QUE DESEAMOS QUE LLEGUEN A LA MUTACIÓN
                                          // O QUE ESTAN EN EL FORM PERO QUEREMOS QUE SE PISEN
        }]

      }catch(err){
        setLoadingFile(false)
        console.log(err)
        eliminarArchivos(adjuntos)
        return [false,err?.message || 'Se produjo un error al ejecutar al inicializar el proceso de guardado de datos']
      }

  } 

  
    const validarCondicionesIniciales = ()=>{
      return [true]
    }

    const iniciarContinuar = ()=>{
          
      if(!validarCondicionesIniciales()[0]){
        alert(validarCondicionesIniciales()[1])
        return
      }
      setContinuar(true)
      setTimeout(() => {
              scrollTop()
      }, 400);
    }

     const validarCondicionesInicialesPaso1 = (validar)=>{

      const validaciones = [];
      
      if(objetoDinamico?.nombre==undefined || !objetoDinamico?.nombre){
        validaciones.push({texto:'Falta identificar el nombre del nuevo ministro',campo:'nombre'}) 
      }

      if(objetoDinamico?.apellido==undefined || !objetoDinamico?.apellido){
        validaciones.push({texto:'Falta identificar el apellido del nuevo ministro',campo:'apellido'}) 
      }

     if(objetoDinamico?.tipo_doc==undefined){
        validaciones.push({texto:'Falta identificar el tipo de documento del nuevo ministro',campo:'tipo_documento'}) 
}

      if(objetoDinamico?.dni==undefined || !objetoDinamico?.dni){
        validaciones.push({texto:'Falta identificar el número de documento del nuevo ministro',campo:'dni'}) 
      }

      if(objetoDinamico?.fecha_nacimiento==undefined || !objetoDinamico?.fecha_nacimiento){
        validaciones.push({texto:'Falta identificar la fecha de nacimiento del nuevo ministro',campo:'fecha_nacimiento'}) 
      }else{
        
        if(!(fechaEsValida(objetoDinamico?.fecha_nacimiento))){
          validaciones.push({texto:'La fecha de naciminento no es válida',campo:'fecha_nacimiento'}) 
        }
      }

      if(objetoDinamico?.nacionalidad==undefined){
        validaciones.push({texto:'Falta identificar la nacionalidad del nuevo ministro',campo:'nacionalidad'}) 
      }

      if(objetoDinamico?.estado_civil==undefined){
        validaciones.push({texto:'Falta identificar el estado civil del nuevo ministro',campo:'estado_civil'}) 
      }

     if((objetoDinamico?.estado_civil?.id == 3 || objetoDinamico?.estado_civil?.id == 6) && (objetoDinamico?.conyuge==undefined || !objetoDinamico?.conyuge)){
        validaciones.push({texto:'Falta identificar el cónyuge del nuevo ministro',campo:'conyuge'}) 
     }

     if(validar && validaciones.length>0){
          return [false,'Hay errores en los datos personales',validaciones]
     }

    return [true]
  }

    const validarCondicionesUbicacionIglesia = (validar)=>{

      const validaciones = [];

      if(objetoDinamico?.provinciaigl?.id==undefined){
        validaciones.push({texto:'Falta identificar la provincia de la iglesia del nuevo ministro',campo:'provincia'})
      }

      if(objetoDinamico?.partidoigl?.id==undefined){
        validaciones.push({texto:'Falta identificar el partido de la iglesia del nuevo ministro',campo:'partido'})
      }

      if(objetoDinamico?.id_region==undefined){
        validaciones.push({texto:'Falta identificar la región del nuevo ministro',campo:'region'})
      }

      if(objetoDinamico?.distrito?.id==undefined){
        validaciones.push({texto:'Falta identificar el distrito del nuevo ministro',campo:'distrito'})
      }
    
      if(validar && validaciones.length>0){
        return [false,'Hay errores en los datos de ubicación de la iglesia',validaciones]
       }

      return [true]

    }

    const validarCondicionesInicialesPaso2 = (validar)=>{

      const validaciones = [];

      if(objetoDinamico?.direccion==undefined || !objetoDinamico?.direccion){
        validaciones.push({texto:'Falta identificar el domicilio del nuevo ministro',campo:'direccion'})
      }

      if(objetoDinamico?.localidad==undefined || !objetoDinamico?.localidad){
        validaciones.push({texto:'Falta identificar la localidad del nuevo ministro',campo:'localidad'})
      }

      if(objetoDinamico?.cod_postal==undefined || !objetoDinamico?.cod_postal){
        validaciones.push({texto:'Falta identificar el código postal del nuevo ministro',campo:'cod_postal'})
      }

      if(objetoDinamico?.provincia?.id==undefined){
        validaciones.push({texto:'Falta identificar la provincia del nuevo ministro',campo:'provincia'})
      }

      if(objetoDinamico?.partido?.id==undefined){
        validaciones.push({texto:'Falta identificar el partido del nuevo ministro',campo:'partido'})
      }

      if(objetoDinamico?.id_region==undefined){
        validaciones.push({texto:'Falta identificar la región del nuevo ministro',campo:'region'})
      }

      if(objetoDinamico?.distrito?.id==undefined){
        validaciones.push({texto:'Falta identificar el distrito del nuevo ministro',campo:'distrito'})
      }
    
      if(validar && validaciones.length>0){
        return [false,'Hay errores en los datos de ubicación',validaciones]
       }

      return [true]

    }
  
    const validarCondicionesInicialesPaso3 = (validar)=>{

    const validaciones = [];

      if(objetoDinamico?.telefono==undefined || !objetoDinamico?.telefono){
        validaciones.push({texto:'El teléfono es obligatorio',campo:'telefono'})
      }

      if(!isValidPhoneNumber(objetoDinamico?.telefono || '')){
        validaciones.push({texto:'El número de teléfono parece ser inválido. Incluya "Código de área local" y "Número de teléfono local". Por ejemplo: 11 1234-5678',campo:'telefono'})
      }


      if(objetoDinamico?.celular==undefined || !objetoDinamico?.celular){
        validaciones.push({texto:'El celular es obligatorio',campo:'celular'})
      }


      if(!isValidPhoneNumber(objetoDinamico?.celular || '')){
        validaciones.push({texto:'El número de celular parece ser inválido. Incluya "Código de área local" y "Número de teléfono local". Por ejemplo: 11 1234-5678',campo:'celular'})
      }

      if(numerosIguales(objetoDinamico?.telefono,objetoDinamico?.celular)){
        validaciones.push({texto:'Los números de teléfono y celular no pueden ser iguales',campo:'celular'})
      }

      if(objetoDinamico?.email==undefined || !objetoDinamico?.email){
        validaciones.push({texto:'El e-mail es obligatorio',campo:'email'})
      }

      if(!regex.EMAIL.test(objetoDinamico?.email)){
        validaciones.push({texto:'El email es inválido',campo:'email'})
      }

      if(validar && validaciones.length>0){
        return [false,'Hay errores en los datos de contacto',validaciones]
       }

      return [true]
    }

    const validarCondicionesInicialesPaso4 = (validar)=>{

      const validaciones = [];
      if(objetoDinamico?.year_conversion==undefined || !objetoDinamico?.year_conversion){
        validaciones.push({texto:'Año de conversión es obligatorio',campo:'year_conversion'})
      }else{

        const year_actual = new Date().getFullYear();

        if((Number(objetoDinamico?.year_conversion) > year_actual) || (Number(objetoDinamico?.year_conversion) < year_actual-100)){
          validaciones.push({texto:`El año de conversion debe ser igual o menor al año actual y mayor a ${year_actual-100} `,campo:'year_conversion'})
        }
      }

      if(objetoDinamico?.year_bautismo==undefined || !objetoDinamico?.year_bautismo){
        validaciones.push({texto:'Año de bautismo en agua es obligatorio',campo:'year_bautismo'})
      }else{

        const year_actual = new Date().getFullYear();

        if((Number(objetoDinamico?.year_bautismo) > year_actual) || (Number(objetoDinamico?.year_bautismo) < year_actual-100)){
          validaciones.push({texto:`El año de bautismo en agua debe ser igual o menor al año actual y mayor a ${year_actual-100} `,campo:'year_bautismo'})
        }
      }

      if(objetoDinamico?.bautismo_es==undefined){
        validaciones.push({texto:'Falta responder sobre el bautismo en el Espíritu Santo',campo:'bautismo_es'})
      }

      if(validar && validaciones.length>0){
        return [false,'Hay errores en los datos de conversión y bautismo',validaciones]
       }

      return [true]
    
    }

     const validarCondicionesInicialesPaso5 = (validar)=>{

      const validaciones = [];

      if(objetoDinamico?.sostenimiento==undefined || !objetoDinamico?.sostenimiento){
        validaciones.push({texto:'El sostenimiento financiero es obligatorio',campo:'sostenimiento'})
      }

      if(typeof objetoDinamico?.sostenimiento == 'string' && objetoDinamico?.sostenimiento.length<20){
        validaciones.push({texto:'Responda como mínimo con 20 caracteres sobre el sostenimiento financiero',campo:'sostenimiento'})
      }

      if(objetoDinamico?.diezmo==undefined){
        validaciones.push({texto:'Falta responder sobre el diezmo',campo:'diezmo'})
      }

      if(validar && validaciones.length>0){
        return [false,'Hay errores en los datos de finanzas y diezmo',validaciones]
       }

      return [true]

    }

    const validarCondicionesInicialesPaso6 = (validar)=>{

      const validaciones = [];

      if(objetoDinamico?.pastores==undefined || !objetoDinamico?.pastores){
        validaciones.push({texto:'Falta ingresar el nombre de los pastores con quienes ha estado trabajando',campo:'pastores'})
      }

      if(objetoDinamico?.pastores instanceof Array){
        if(objetoDinamico?.pastores.length<1){
          validaciones.push({texto:'Falta ingresar el nombre al menos un pastor con quien ha estado trabajando',campo:'pastores'})
        }
      }

     
      if(validar && validaciones.length>0){
        return [false,'Hay errores en los datos de pastores',validaciones]
       }

      return [true]
    }

    const validarCondicionesInicialesPaso7 = (validar)=>{

      const validaciones = [];

      if(objetoDinamico?.nombrepastor==undefined || !objetoDinamico?.nombrepastor){
        validaciones.push({texto:'Falta identificar el nombre del pastor',campo:'nombrepastor'})
      }

      if(objetoDinamico?.emailpastor==undefined || !objetoDinamico?.emailpastor){
        validaciones.push({texto:'Falta identificar el email del pastor',campo:'emailpastor'})
      }

      if(!regex.EMAIL.test(objetoDinamico?.emailpastor)){
        validaciones.push({texto:'El email del pastor es inválido',campo:'emailpastor'})
      }

      if(objetoDinamico?.nombreanciano==undefined || !objetoDinamico?.nombreanciano){
        validaciones.push({texto:'Falta identificar el nombre del anciano/diácono',campo:'nombreanciano'})
      }

      if(objetoDinamico?.emailanciano==undefined || !objetoDinamico?.emailanciano){
        validaciones.push({texto:'Falta identificar el email del anciano/diácono',campo:'emailanciano'})
      }

      if(!regex.EMAIL.test(objetoDinamico?.emailanciano)){
        validaciones.push({texto:'El email del anciano/diácono es inválido',campo:'emailanciano'})
      }

      if((objetoDinamico?.estado_civil?.id == 3 || objetoDinamico?.estado_civil?.id == 6)){
          if(objetoDinamico?.conyuge==undefined || !objetoDinamico?.conyuge){
            validaciones.push({texto:'Falta identificar el nombre del cónyuge',campo:'nombreconyuge'})
          }

          if(objetoDinamico?.emailconyuge==undefined || !objetoDinamico?.emailconyuge){
            validaciones.push({texto:'Falta identificar el email del conyuge',campo:'emailconyuge'})
          }

          if(!regex.EMAIL.test(objetoDinamico?.emailconyuge)){
            validaciones.push({texto:'El email del cónyuge es inválido',campo:'emailconyuge'})
          }
      }
      
      if(validar && validaciones.length>0){
        return [false,'Hay errores en los datos de referencias',validaciones]
       }

      return [true]

    }

    const callbackValidate = async (values)=>{

      const validarKey = await keyNoValida(datosPatrocinante._id);

      console.log(validarKey)
      if(!validarKey[0]){
        return [false,validarKey[1]]
      }

      const validardni = await dniEstaEnUso(objetoDinamico.dni);

      console.log(validardni)
      if(!validardni[0]){
        return [false,validardni[1]]
      }

      if(!analiticoFile)
      {
        return [false,'Falta adjuntar el archivo de analítico']
      }

      if(!dniFrenteFile)
      {
        return [false,'Falta adjuntar el archivo del DNI (Frente)']
      }

      if(!dniReversoFile)
      {
        return [false,'Falta adjuntar el archivo del DNI (Reverso)']
      }

      if(!foto4x4File)
      {
        return [false,'Falta adjuntar la foto 4 x 4']
      }

      if(!antecedentes_penFile)
      {
        return [false,'Falta adjuntar el certificado de antecedentes penales']
      }

      if(objetoDinamico?.estado_civil?.id==3 || objetoDinamico?.estado_civil?.id==6 ){
        if(!certificadoMatrimonioFile)
        {
          return [false,'Falta adjuntar el certificado de matrimonio']
        }
      }

      if(objetoDinamico.compromiso!=true)
      {
        return [false,'Debe aceptar el documento de compromiso ministerial UAD']
      }

      if(objetoDinamico.doctrina!=true)
      {
        return [false,'Debe aceptar el documento de doctrinas fundamentales UAD']
      }

      if(objetoDinamico.estatutos!=true)
      {
        return [false,'Debe aceptar el documento de estatutos y testimonios UAD']
      }

      setvalidarCampos(true)
      let validacion_parcial;

      validacion_parcial = validarCondicionesInicialesPaso1(true);

      if(validacion_parcial[0]==false){
          return[false,validacion_parcial[1]]
      }

      validacion_parcial = validarCondicionesInicialesPaso2(true);

      if(validacion_parcial[0]==false){
        return[false,validacion_parcial[1]]
      }

      validacion_parcial = validarCondicionesInicialesPaso3(true);

      if(validacion_parcial[0]==false){
        return[false,validacion_parcial[1]]
      }
   
      validacion_parcial = validarCondicionesInicialesPaso4(true);

      if(validacion_parcial[0]==false){
        return[false,validacion_parcial[1]]
      }

      validacion_parcial = validarCondicionesInicialesPaso5(true);

      if(validacion_parcial[0]==false){
        return[false,validacion_parcial[1]]
      }

      validacion_parcial = validarCondicionesInicialesPaso6(true);

      if(validacion_parcial[0]==false){
        return[false,validacion_parcial[1]]
      }

      validacion_parcial = validarCondicionesInicialesPaso7(true);

      if(validacion_parcial[0]==false){
        return[false,validacion_parcial[1]]
      }

      validacion_parcial = validarCondicionesUbicacionIglesia(true);

      if(validacion_parcial[0]==false){
        return[false,validacion_parcial[1]]
      }

      if(objetoDinamico.id_tramite_patrocinio==undefined || objetoDinamico.id_tramite_patrocinio==''){
        return[false,'No se pudo identificar el id del trámite de patrocinio']
      }

      return [true]

    }

    const handleCheck = (e)=>{
       
      if(e.target.checked){
          setObjetoDinamico({...objetoDinamico,[e.target.name]:true})
      }else{
        setObjetoDinamico({...objetoDinamico,[e.target.name]:false})
      }
  }

  const handleAceptacion = (campo,valor)=>{
       
    if(valor){
        setObjetoDinamico({...objetoDinamico,[campo]:true})
    }else{
      setObjetoDinamico({...objetoDinamico,[campo]:false})
    }
}    
          

    const CustomSubmit = ({submit,values})=>{
      const [esperarRespuesta,setEsperarRespuesta] = React.useState(false)
      const [codigo,setCodigo] = React.useState('')
      const [envios,setEnvios] = React.useState(0)
      const [identificador,setIdentificador] = React.useState('')
      const [enviando,setEnviando] = React.useState(false)

      const validarpaso = ()=>{
              callbackValidate(values)
              .then(resultado=>{
                      if (resultado[0]==false){
                          snackbar.showMessage(resultado[1],'error')
                          return 
                      }else{
                          setEsperarRespuesta(true)
                      }
              })
  
      }
  
      const handlechange =(e)=>{
         if(regex.NUMERIC.test(e.target.value)){
            setCodigo(e.target.value)
         }
      }
  
      const verificarCodigo = async ()=>{
  
        try{
          const verificacion = await Axios.get(`${process.env.REACT_APP_API_UAD_BASE}/api/tablasgenerales/validarcodigo/${identificador}/${codigo}`)
          if(verificacion.data.resultado==true){
            Swal.fire({
              text:`El código es correcto`,
              icon: 'success',
              showCancelButton:true,
              confirmButtonText:'Enviar solicitud',
              cancelButtonText:'Cancelar'
          }).then(
              resultado=>{
                  if (resultado.value){
                      submit();
                  }else{
                      console.log("Se canceló la operación de la solicitud")
                  }
              }
          )
          }else{
            Swal.fire(
              'El código no es correcto',
              'Verifique el código o vuelva a enviarlo',
              'error'
            )
          }
  
        }catch(err){
            console.log(err)
            Swal.fire(`No se pudo verificar el código`,err?.response?.data?.message || '','error')
        }
  }
  
      const enviarCodigo = async ()=>{
        const codigo = Math.random().toString().toUpperCase().slice(2, 8)
        const identificador = uuidv4();
  
        setIdentificador(identificador);
  
        try{
            setEnviando(true)
            const envio = await Axios.post(`${process.env.REACT_APP_API_UAD_BASE}/api/tablasgenerales/codigoverificador/movil/${identificador}`,{nombre:objetoDinamico.nombre,numero:objetoDinamico.celular})
            setEnvios(envios+1)
            setCodigo('')
            Swal.fire(`El mensaje fue enviado a ${objetoDinamico.celular}`,'Enviamos un código de 6 dígitos por SMS a su celular','info')
            .then(()=>{
              setTimeout(() => {
                  hacerFoco('verif-cod')
              }, 1000);
                
            })

            setEnviando(false)
          }catch(err){
            console.log(err)
            setEnviando(false)
            Swal.fire(`No se pudo enviar el código`,err?.response?.data?.message || '','error')
        }
      }
  

      return  <>
              <Button onClick={validarpaso} variant='outlined' className='!bg-blue-400 text-white w-full text-center !ml-4'>
                  Continuar 
              </Button>
              <AlertDialog
                  titulo="Validación del número de celular"
                  open={esperarRespuesta}
                  procesarCancelar={()=>setEsperarRespuesta(false)}
              >
                  <Box>
                      <p> Antes de enviar la solicitud necesitamos validar su número de celular</p>
                      <br />
                      <p>Vamos a enviar un mensaje a <b>{objetoDinamico.celular}</b> con un código de 6 dígitos</p>
                      <br />
                      <p>Por favor haga clic en el botón "ENVIAR CÓDIGO" y luego ingrese el código recibido</p>
                      
                      <Box style={{marginTop:'20px', marginBottom:'20px',flexDirection:'column',display:'flex',justifyContent:'center'}}>
                          <Button onClick={enviarCodigo} variant="outlined" color="secondary">
                                {envios==0 ? 'Enviar código' : 'Reenviar código'}
                          </Button>
                          {enviando && <LoaderCircular/>}
                      </Box>
  
                      <Box style={{marginTop:'20px', marginBottom:'20px',display:'flex',justifyContent:'space-evenly'}}>
                          <input id="verif-cod" maxLength={6} value={codigo} placeholder='Ingrese el código aquí' onChange={handlechange} style={{border:'solid 1px red',padding:'10px'}} type="text"/>
                          {<Button onClick={verificarCodigo} style={{background:'steelblue'}} variant="outlined">
                                Verificar código
                          </Button>}
                      </Box>
  
                  </Box>
              </AlertDialog>
      </> 
     
    }

const determinarNombreDocumento = (documento) =>{

  
  switch (documento){
    
    case 'doctrina':
      return 'Doctrinas fundamentales UAD'
    case 'estatutos':
      return 'Estatutos y testimonio UAD'
    case 'compromiso':
      return 'Compromiso ministerial UAD'
    default : return false
  } 
}

const determinarEstado = (documento,objetoDinamico) =>{
  
  switch (documento){
    
    case 'doctrina':
      return objetoDinamico?.doctrina==undefined ? null: objetoDinamico?.doctrina
    case 'estatutos':
      return objetoDinamico?.estatutos==undefined ? null: objetoDinamico?.estatutos
    case 'compromiso':
      return objetoDinamico?.compromiso==undefined ? null: objetoDinamico?.compromiso
    default : return false
  } 
}    

return {
    // --- ESTADOS DE CARGA Y NAVEGACIÓN ---
    loadingFile,
    continuar,
    setContinuar,
    validarCampos,
    // --- ESTADOS DE DATOS ---
    objetoDinamico,
    setObjetoDinamico,
    documento,
    setDocumento,
    lecturas,
    setLecturas,

    // --- ESTADOS DE ARCHIVOS (FILES) ---
    analiticoFile,
    setAnaliticoFile,
    dniFrenteFile,
    setDniFrenteFile,
    dniReversoFile,
    setDniReversoFile,
    foto4x4File,
    setFoto4x4File,
    antecedentes_penFile,
    setAntecedentesPenFile,
    certificadoMatrimonioFile,
    setCertificadoMatrimonioFile,
    otroArchivo,
    setOtroArchivo,

    // --- MÉTODOS DE MANEJO DE EVENTOS ---
    handleAceptacion,
    iniciarContinuar,

    // --- MÉTODOS DE VALIDACIÓN ---
    callbackPrevio,
    callbackValidate,
    validarCondicionesInicialesPaso1,
    validarCondicionesInicialesPaso2,
    validarCondicionesInicialesPaso3,
    validarCondicionesInicialesPaso4,
    validarCondicionesInicialesPaso5,
    validarCondicionesInicialesPaso6,
    validarCondicionesInicialesPaso7,

    // --- COMPONENTES E INYECTADOS ---
    CustomSubmit, // Componente para el proceso de SMS y Submit
    
    // --- DATOS EXTERNOS RE-EXPUESTOS (Opcional, pero útil) ---
    usuario,
    campos_formulario,
    provincias,
    partidos,
    tiposDoc,
    nacionalidades,
    estadosCiviles,
    adjuntos,

    determinarEstado,
    determinarNombreDocumento
};

}       

const numerosIguales = (telefono,celular)=>{
  
  if(typeof telefono == 'string' && typeof celular == 'string' ){
      if(telefono.trim()===celular.trim()){
          return true
      }else{
          return false
      }
  }else{
      return false
  }

}